import styled from "styled-components";
import { device } from "../device";

const H3 = styled.h3`
    margin: 0 0 16px;

    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;

    @media ${device.lg} {
        font-size: 32px;
        margin: 0 0 24px;
    }
`;

export default H3